<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <h2 class="text-center">Dodaj nowy ciągnik</h2>
    <form @submit.prevent="createVehicle">
      <div class="mb-3">
        <label for="place-name" class="form-label">Nazwa</label>
        <input type="text" class="form-control" id="place-name" v-model="name">
      </div>
      <button type="submit" class="btn btn-primary">Zatwierdź</button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import Swal from 'sweetalert2'
export default {
  name: 'CreateVehicle',
  components: { Navbar },
  data () {
    return {
      name: '',
      textColor: '#000000',
      backgroundColor: '#ffffff'
    }
  },
  methods: {
    async createVehicle () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postData = {
        name: this.name,
        textColor: this.textColor,
        backgroundColor: this.backgroundColor,
        plateNumber: this.name
      }
      try {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, postData, config)
        await Swal.fire('Dodano ciągnik do systemu', '', 'success')
      } catch (e) {
        console.log(e)
        await Swal.fire('Coś poszło nie tak', '', 'error')
      }
    }
  }
}
</script>
